import {observer} from 'mobx-react';
import React, {useEffect} from 'react';

import {TextSkeleton} from '@udemy/react-reveal-components';
import {StreaksBox, StreakUserLectureConsumptionWeeklyStore} from '@udemy/react-student-retention';
import {useUDData} from '@udemy/ud-data';

interface StreaksUnitProps {
    className?: string;
}

export const StreaksUnit = observer((props: StreaksUnitProps) => {
    const {className} = props;
    const udData = useUDData();
    const [streaksStore] = React.useState(() => new StreakUserLectureConsumptionWeeklyStore());

    useEffect(() => {
        streaksStore.load();
    }, [streaksStore]);

    if (streaksStore.errorState || !streaksStore.streakData) {
        return null;
    }

    if (udData.me.isLoading || streaksStore.isLoading) {
        return <TextSkeleton withTitle={true} lineCountPerParagraph={2} />;
    }

    return (
        <div className={className}>
            <StreaksBox streakData={streaksStore.streakData} />
        </div>
    );
});
